import React,{useState} from 'react';
import coverImage1 from '../../assets/img/feed-imgs/right/follow/follow-cover1.png';
import coverImage2 from '../../assets/img/feed-imgs/right/follow/follow-cover2.png';
import refreshButton from '../../assets/img/feed-imgs/right/refresh.svg'
import userImage1 from '../../assets/img/feed-imgs/right/follow/follow-user1.png';
import userImage2 from '../../assets/img/feed-imgs/right/follow/follow-user2.png';
import userImage3 from '../../assets/img/feed-imgs/right/follow/follow-user3.png';
import userImage4 from '../../assets/img/feed-imgs/right/follow/follow-user4.png';

const FollowingPeople = () => {
    const [ followingData,setFollowingData ] = useState(false)
    const fakeDataOne = [
        {
            coverImage : coverImage1,
            userImage: userImage1,
            fullName: "Sonia Lee",
            userName: " @slee255"
           
        },
        {
            coverImage : coverImage2,
            userImage: userImage2,
            fullName: "Clifford Jack",
            userName: "@cliffjack"
            
        },
        {
            coverImage : coverImage1,
            userImage: userImage3,
            fullName: "Mona Sanders",
            userName: "@monasanders"
            
        },
        {
            coverImage : coverImage2,
            userImage: userImage4,
            fullName: "Sonia Lee",
            userName: "@slee255"
            
        },
        {
            coverImage : coverImage2,
            userImage: userImage2,
            fullName: "Clifford Jack",
            userName: "@cliffjack"
            
        },
        {
            coverImage : coverImage1,
            userImage: userImage1,
            fullName: "Sonia Lee",
            userName: " @slee255"
           
        },
    ]

    const fakeDataTwo = [
        {
            coverImage : coverImage1,
            userImage: userImage1,
            fullName: "Sonia Lee",
            userName: " @slee255"
           
        },
        {
            coverImage : coverImage2,
            userImage: userImage2,
            fullName: "Clifford Jack",
            userName: "@cliffjack"
            
        },
        {
            coverImage : coverImage1,
            userImage: userImage3,
            fullName: "Mona Sanders",
            userName: "@monasanders"
            
        }
    ]
   
    
    const handleFollowingPeopleData = () =>{
        setFollowingData(!followingData)
    }

    return (
        <div className="row mb-3">
            <div className="row mb-4">
                <div className="col-12 d-flex justify-content-between align-items-center"><span className="happening">People to Follow</span><img src={refreshButton} alt="" /></div>
            </div>
                   
                    {
                        fakeDataTwo.map ( (item,index) =>  <div className={ !followingData ? `col-12 mt-3 d-block` : 'd-none' } key={index} >
                                <div className="position-relative" >
                                    <img className="w-100" src={item.coverImage}  alt="" />
                                        <div className="position-absolute w-100 h-100 px-3 top-0 d-flex justify-content-start align-items-center f_screen"
                                        >
                                            <img className="me-3" src={item.userImage} style={{fontSize: "18px"}} alt="" />
                                            <div className="d-grid gap-1">
                                                <span className="f_un">{item.fullName}</span>
                                                <span className="f_uid">{item.userName}</span></div>
                                        </div>
                                </div>
                            </div>
                        ) 
                    
                    }
                    {
                      followingData && fakeDataOne.map ( (item,index) =>  <div className="col-12 mt-3" key={index} >
                                <div className="position-relative" >
                                    <img className="w-100" src={item.coverImage} alt="" />
                                        <div className="position-absolute w-100 h-100 px-3 top-0 d-flex justify-content-start align-items-center f_screen "
                                        >
                                            <img className="me-3 " src={item.userImage} style={{fontSize: "18px"}} alt="" />
                                            <div className="d-grid gap-1">
                                                <span className="f_un">{item.fullName}</span>
                                                <span className="f_uid">{item.userName}</span></div>
                                        </div>
                                </div>
                            </div>
                        ) 
                    }
            <div className="row mt-4">
                <div className="col-12">
                    {
                        followingData ? <span className="login_link cursor-pointer" onClick={handleFollowingPeopleData}>Less then</span> : <span className="login_link cursor-pointer" onClick={handleFollowingPeopleData}>Show more</span>
                    }
                    
                </div>
            </div>
        </div>
    );
};

export default FollowingPeople;